export function convertToCSV(data: any) {
	const header = Object.keys(data[0]).join(",");
	const rows = data.map((row: any) => Object.values(row).join(",")).join("\n");
	return `${header}\n${rows}`;
}

export function formatDateTimeBrazil(date: Date): string {
	const brazilDate = new Date(
		date.toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }),
	);
	const day = (
		brazilDate.getHours() - 3 > 0
			? brazilDate.getDate()
			: brazilDate.getDate() - 1
	)
		.toString()
		.padStart(2, "0");
	const month = (brazilDate.getMonth() + 1).toString().padStart(2, "0");
	const year = brazilDate.getFullYear();
	const hours = (
		brazilDate.getHours() - 3 > 0
			? brazilDate.getHours() - 3
			: brazilDate.getHours() - 3 + 24
	)
		.toString()
		.padStart(2, "0");
	const minutes = brazilDate.getMinutes().toString().padStart(2, "0");
	const seconds = brazilDate.getSeconds().toString().padStart(2, "0");

	return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export function getStartOfDay(date: Date): Date {
	return new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		0,
		0,
		0,
		0,
	);
}

export function getEndOfDay(date: Date): Date {
	return new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		23,
		59,
		59,
		999,
	);
}

export function hexToDecimal(hex: string): number {
	console.log({ hex: parseInt(hex, 16) });
	return parseInt(hex, 16);
}
